import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import styles from './Link.module.scss.js';

var _excluded = ["children", "disabled", "hideText", "href", "icon", "className", "openNewWindow", "onClick", "preset", "variant", "hrefClick"];
var Link = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _cx;
  var children = _ref.children,
    disabled = _ref.disabled,
    hideText = _ref.hideText,
    href = _ref.href,
    icon = _ref.icon,
    className = _ref.className,
    openNewWindow = _ref.openNewWindow,
    onClick = _ref.onClick,
    preset = _ref.preset,
    variant = _ref.variant,
    hrefClick = _ref.hrefClick,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (onClick) {
    props.onClick = onClick;
  } else if (href) {
    props.href = href;
    if (hrefClick) {
      props.onClick = hrefClick;
    }
  }
  if (openNewWindow) {
    props.rel = 'noopener noreferrer';
    props.target = '_blank';
  }
  var classes = cx(styles.link, (_cx = {}, _cx[styles.disabled] = disabled, _cx[styles.withIcon] = !!icon, _cx[styles[preset + "Preset"]] = preset, _cx), variant && "link-" + variant, className);
  if (icon) {
    return /*#__PURE__*/React.createElement("a", _extends({
      className: classes
    }, props, {
      ref: ref
    }), icon, " ", children && /*#__PURE__*/React.createElement("span", {
      className: cx(styles.text, {
        'sr-only': hideText
      })
    }, children));
  }
  return /*#__PURE__*/React.createElement("a", _extends({
    className: classes
  }, props, {
    ref: ref
  }), children);
});
Link.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  disabled: PropTypes.bool,
  hideText: PropTypes.bool,
  href: PropTypes.string,
  icon: PropTypes.any,
  onClick: PropTypes.func,
  hrefClick: PropTypes.func,
  openNewWindow: PropTypes.bool,
  /** Style preset */
  preset: PropTypes.oneOf(['default', 'pill']),
  variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger', 'warning', 'info'])
};
Link.defaultProps = {
  disabled: false,
  preset: 'default'
};

export { Link as default };
//# sourceMappingURL=index.js.map
